// extracted by mini-css-extract-plugin
export var dateLabel = "_29-0";
export var dateLabelError = "_29-1";
export var fullWidth = "_29-2";